<template>
  <Menu
    v-slot="{ open }"
    as="div"
    class="tw-relative tw-inline-block tw-min-w-[10rem] tw-text-left md:tw-max-w-[10rem]"
  >
    <MenuButton
      class="tw-inline-flex tw-h-[2.5rem] tw-w-full tw-items-center tw-justify-between tw-gap-1 tw-rounded-md tw-border tw-border-solid tw-border-gray-300 tw-bg-gray-50 tw-px-5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-gray-700"
      :class="[buttonHoverCss, open || sortDirection ? buttonActiveCss : '']"
    >
      Sort by
      <ChevronDownIcon class="tw-h-5 tw-w-5" aria-hidden="true" />
    </MenuButton>
    <MenuItems
      class="tw-absolute tw-right-0 tw-z-10 tw-mt-2 tw-w-56 tw-origin-top-right tw-space-y-1 tw-overflow-hidden tw-rounded-lg tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none"
    >
      <MenuItem v-slot="{ active }">
        <button
          class="tw-flex tw-w-full tw-items-center tw-gap-x-3 tw-px-4 tw-py-2 tw-text-base tw-font-normal tw-text-gray-700 tw-transition-colors"
          :class="[active ? buttonActiveCss : '', buttonHoverCss]"
          @click="setSortDirection('asc')"
        >
          <BarsArrowDownIcon class="tw-h-4 tw-w-4" aria-hidden="true" />
          Oldest to newest
        </button>
      </MenuItem>

      <MenuItem v-slot="{ active }">
        <button
          class="tw-flex tw-w-full tw-items-center tw-gap-x-3 tw-px-4 tw-py-2 tw-text-base tw-font-normal tw-text-gray-700 tw-transition-colors"
          :class="[active ? buttonActiveCss : '', buttonHoverCss]"
          @click="setSortDirection('desc')"
        >
          <BarsArrowUpIcon class="tw-h-4 tw-w-4" aria-hidden="true" />
          Newest to oldest
        </button>
      </MenuItem>
    </MenuItems>
  </Menu>
</template>

<script setup lang="ts">
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

import BarsArrowDownIcon from '~icons/heroicons-solid/bars-arrow-down'
import BarsArrowUpIcon from '~icons/heroicons-solid/bars-arrow-up'
import ChevronDownIcon from '~icons/heroicons-solid/chevron-down'

const { getThemeTokenString } = useTheme()

const buttonHoverCss = getThemeTokenString(['hover-background', 'hover-border'])

const buttonActiveCss = getThemeTokenString(['light-background', 'dark-border'])

defineProps<{
  sortDirection: 'asc' | 'desc' | null
}>()

const emit = defineEmits(['update:sortDirection'])

function setSortDirection(direction: 'asc' | 'desc') {
  emit('update:sortDirection', direction)
}
</script>
